import { render, staticRenderFns } from "./News.vue?vue&type=template&id=df1f25be&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df1f25be')) {
      api.createRecord('df1f25be', component.options)
    } else {
      api.reload('df1f25be', component.options)
    }
    module.hot.accept("./News.vue?vue&type=template&id=df1f25be&", function () {
      api.rerender('df1f25be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/views/news/News.vue"
export default component.exports